(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.controller('ExtractedRestoreRequestsController', ["$scope", "$q", "path", "modulesManager", "tablePaginationHelper", "objectTypeDao", "$routeParams", "routeHelper", "emailDao", "modals", "remediationProperties", "manualActionDao", "policyPropertyParser", "defaultListConverter", "columnsHelper", "$timeout", function ($scope, $q, path, modulesManager, tablePaginationHelper, objectTypeDao, $routeParams, routeHelper, emailDao, modals, remediationProperties, manualActionDao, policyPropertyParser, defaultListConverter, columnsHelper, $timeout) {
        var converters = {
            attachmentsConverter: function (text, columnId, columnsMap, args) {
                if (!text || !text.length) {
                    return '';
                }
                var maxInlineCount = 3;
                var inlineCount = text.length > maxInlineCount ? maxInlineCount - 1 : text.length;
                var maxTipCount = 10;
                var result = _(text).chain().first(inlineCount).map(function (file) {
                    return '#' + JSON.stringify({
                        display: 'link',
                        'class': 'attachment-element',
                        text: file.name,
                        type: 'profile',
                        entityType: file.entity_type,
                        id: file.entity_id,
                        tooltip: {
                            content: { text: file.name },
                            style: { classes: 'qtip-standard max-half-window' },
                            position: {
                                at: 'bottom center',
                                my: 'top center'
                            }
                        }
                    });
                }).value().join('');
                if (text.length > inlineCount) {
                    var tipFiles = _(text).chain().rest(inlineCount).first(maxTipCount).value();
                    var moreText = '';
                    if (inlineCount + tipFiles.length < columnsMap.attachments_count) {
                        moreText = '<div class="white-space-nowrap">' + (columnsMap.attachments_count - inlineCount - tipFiles.length) + ' more</div>';
                    }
                    result += '#' + JSON.stringify({
                        display: 'link',
                        type: 'profile',
                        entityType: args.entityType,
                        id: columnsMap.entity_id,
                        'class': 'attachment-element',
                        text: columnsMap.attachments_count - inlineCount + ' more',
                        tooltip: {
                            content: {
                                text: _(tipFiles).map(function (file) {
                                    return '<div class="white-space-nowrap">' + file.name + '</div>';
                                }).join('') + moreText
                            },
                            position: {
                                at: 'bottom center',
                                my: 'top center',
                                viewport: true
                            }
                        }
                    });
                }
                return result;
            },
            actionsConverter: function (text, columnId, columnsMap, args) {
                if (columnsMap.is_attachment_restored) {
                    return;
                }
                var result = '#' + JSON.stringify({
                    display: 'text',
                    'class': 'restore-action-link fa fa-check',
                    tooltip: 'Approve',
                    clickEvent: {
                        name: 'restore-request-approve',
                        entityId: columnsMap.entity_id
                    }
                });
                if (!columnsMap.is_restore_declined) {
                    result += '#' + JSON.stringify({
                        display: 'text',
                        'class': 'restore-action-link fa fa-times',
                        tooltip: 'Decline',
                        clickEvent: {
                            name: 'restore-request-deny',
                            entityId: columnsMap.entity_id
                        }
                    });
                }
                return result;
            },
            restoreRequestConverter: function (text, columnId, columnsMap, args) {
                return '#' + JSON.stringify({
                    display: 'text',
                    text: text,
                    clickEvent: {
                        name: 'show-restore-request',
                        request: columnsMap
                    }
                });
            }
        };
        $scope.enabledSaases = [];
        $scope.model = { currentModule: $routeParams.module };
        var availableSaases = [
            'office365_emails',
            'google_mail'
        ];
        modulesManager.init().then(function () {
            $scope.enabledSaases = _(modulesManager.activeSaasApps()).filter(function (saas) {
                return _(availableSaases).contains(saas.name);
            }).map(function (saas) {
                return $.extend({ href: routeHelper.getHref('extracted-restore-requests', { module: saas.name }) }, saas);
            });
        });
        var objectTypesPromise = objectTypeDao.retrieve(false);
        $scope.reload = function () {
            $scope.processingActions = {};
            if ($scope.tableHelper) {
                $scope.tableHelper.destroy();
            }
            if ($scope.enabledSaases.length) {
                var currentModuleEnabled = _($scope.enabledSaases).find(function (saas) {
                    return saas.name === $scope.model.currentModule;
                });
                if (!currentModuleEnabled) {
                    routeHelper.redirectTo('extracted-restore-requests', { module: $scope.enabledSaases[0].name });
                    return;
                }
            } else {
                return $timeout(function () {
                    $scope.reload();
                }, 1000);
            }
            $scope.tableOptions = {
                pagesAround: 2,
                pageSize: 20,
                pagination: {
                    page: 1,
                    ordering: {}
                },
                asDivs: true,
                infinite: true,
                reloadUuid: true,
                saveState: true,
                showWorkingIndicator: true,
                disableTop: true,
                orderDisplayMode: 'highlight-column',
                dropdownHeader: true,
                actions: [
                    {
                        label: 'Restore...',
                        display: 'button',
                        active: function () {
                            return $scope.tableHelper.getSelectedIds().length > 0;
                        },
                        execute: function () {
                            executeAction('restore', $scope.tableHelper.getSelectedIds(), true);
                        }
                    },
                    {
                        label: 'Decline...',
                        display: 'button',
                        active: function () {
                            return $scope.tableHelper.getSelectedIds().length > 0;
                        },
                        execute: function () {
                            executeAction('decline', $scope.tableHelper.getSelectedIds(), true);
                        }
                    }
                ]
            };
            $q.all([
                objectTypesPromise,
                path('gui-v2').ctrl('extracted-restore-requests').json($scope.model.currentModule + '.restore-requests').retrieve()
            ]).then(function (responses) {
                var config = responses[1].data;
                $scope.options = {
                    columns: config.columns,
                    options: $.extend({ disableSelectAll: true }, config.options)
                };
                $scope.entityType = config.entityType;
                $scope.sources = responses[0].data.sources($scope.entityType);
                $scope.actionTypes = responses[0].data.actionTypes[$scope.entityType];
                $scope.actions = {
                    'restore': {
                        action: _($scope.actionTypes).find(function (action) {
                            return action.id === config.restoreActionId;
                        }),
                        confirmText: function (ids) {
                            return ids.length + ' email' + (ids.length === 1 ? '' : 's') + ' will be restored.';
                        }
                    },
                    'decline': {
                        action: _($scope.actionTypes).find(function (action) {
                            return action.id === config.declineActionId;
                        }),
                        confirmText: function (ids) {
                            return ids.length + ' request' + (ids.length === 1 ? '' : 's') + ' will be declined.';
                        }
                    }
                };
                $scope.tableHelper = tablePaginationHelper($scope, $scope.tableOptions, $scope.options, function (args) {
                    var q = emailDao.extractedRestoreRequests($scope.options.columns).converter(defaultListConverter, function () {
                        return {
                            columns: $scope.options.columns,
                            converters: converters
                        };
                    });
                    return q.pagination(args.offset, args.limit).order(args.ordering.columnName, args.ordering.order, _(args.ordering.columnName.split(',')).map(function () {
                        return 'last';
                    }).join(','));
                }, function (tableModel) {
                    $scope.tableModel = tableModel;
                    $scope.tableOptions.infoText = $scope.tableHelper.getTotal() + ' requests';
                    updateRowClasses();
                });
            });
        };
        function executeAction(actionType, ids, alwaysConfirm) {
            var actionDef = $scope.actions[actionType];
            var action = actionDef.action;
            var params = _(action.attributes).chain().filter(function (param) {
                return _(param.label).isString();
            }).map(function (param) {
                return $.extend(true, {}, param);
            }).value();
            var getProperties = _.memoize(remediationProperties($scope.sources.properties));
            if (alwaysConfirm || ids.length > 1) {
                params.push({
                    type: 'message',
                    message: '#' + JSON.stringify({
                        display: 'text',
                        'class': 'display-block',
                        text: actionDef.confirmText(ids)
                    }) + '#' + JSON.stringify({
                        display: 'text',
                        'class': 'display-block',
                        text: 'Are you sure you want to continue?'
                    }),
                    paramClass: 'full-width-param'
                });
            }
            var visibleParam = _(params).find(function (param) {
                if (param.type !== 'property') {
                    return true;
                }
                var properties = getProperties(param.propertyType);
                if (properties[0].sub.length !== 1) {
                    return true;
                }
                if (properties[properties[0].sub[0]].selectable) {
                    return false;
                }
                return true;
            });
            var p;
            if (visibleParam) {
                p = modals.params([{
                        params: params,
                        lastPage: true,
                        getProperties: getProperties
                    }], action.label, '', { noDataLabel: action.confirm });
            } else {
                p = $q.when(_(params).chain().map(function (param) {
                    if (!param.id) {
                        return;
                    }
                    var data = param.data;
                    if (param.type === 'property') {
                        var properties = getProperties(param.propertyType);
                        if (properties[0].sub.length == 1) {
                            var firstProperty = properties[_(properties[0].sub).first()];
                            if (firstProperty.selectable) {
                                data = firstProperty.id;
                            }
                        }
                        if (_(data).isString()) {
                            data = data.replace(/^\{/, '').replace(/}$/, '');
                            if (data.length) {
                                data = '.' + data;
                            }
                        }
                        data = policyPropertyParser(data);
                        if (_(data.fullId).isString()) {
                            if (data.fullId[0] == '.') {
                                data = '{' + data.fullId.slice(1) + '}';
                            } else {
                                data = '{' + data.fullId + '}';
                            }
                        } else {
                            data = undefined;
                        }
                    }
                    return [
                        param.id,
                        data
                    ];
                }).compact().object().value());
            }
            p.then(function (data) {
                var body = {
                    name: action.id,
                    attributes: data
                };
                addToUpdater(ids);
                updateRowClasses();
                $scope.tableHelper.clearSelection();
                manualActionDao.create($scope.entityType, ids, body).then(function () {
                    updateEmails();
                });
            });
        }
        function updateRowClasses() {
            if (!$scope.tableModel || !$scope.tableModel.data) {
                return;
            }
            var primaryColumn = columnsHelper.getPrimaryIdx($scope.options.columns);
            _($scope.tableModel.data).each(function (row, idx) {
                $scope.tableModel.rowClasses[idx] = $scope.tableModel.rowClasses[idx] || {};
                if ($scope.processingActions[row[primaryColumn].originalText]) {
                    $scope.tableModel.rowClasses[idx].processing = true;
                } else {
                    delete $scope.tableModel.rowClasses[idx].processing;
                }
            });
        }
        function addToUpdater(ids) {
            if (!$scope.tableModel || !$scope.tableModel.data) {
                return;
            }
            var idsMap = _(ids).chain().map(function (id) {
                return [
                    id,
                    {}
                ];
            }).object().value();
            var primaryColumn = columnsHelper.getPrimaryIdx($scope.options.columns);
            _($scope.tableModel.data).each(function (row) {
                if (!idsMap[row[primaryColumn].originalText]) {
                    return;
                }
                idsMap[row[primaryColumn].originalText].old = row;
            });
            _(idsMap).each(function (data, id) {
                if (data.old) {
                    $scope.processingActions[id] = {
                        updated: moment(),
                        old: angular.copy(data.old)
                    };
                }
            });
        }
        var statusUpdateTimer = false;
        function rowMatchesFilters(row) {
            var restoredColumn = columnsHelper.getIdxByIdStrict($scope.options.columns, 'is_attachment_restored');
            var declinedColumn = columnsHelper.getIdxByIdStrict($scope.options.columns, 'is_restore_declined');
            return (!restoredColumn || !row[restoredColumn].originalText) && (!declinedColumn || !row[declinedColumn].originalText);
        }
        function updateEmails() {
            if (statusUpdateTimer) {
                $timeout.cancel(statusUpdateTimer);
                statusUpdateTimer = false;
            }
            var interval = 2000;
            var expiredTime = moment().subtract(60, 'seconds');
            var needRefresh = [];
            $scope.processingActions = _($scope.processingActions).pick(function (data, id) {
                if (data.updated.isBefore(expiredTime)) {
                    return false;
                }
                needRefresh.push(id);
                return true;
            });
            if (needRefresh.length) {
                emailDao.extractedRestoreRequests().params({ entity_id: needRefresh.join(',') }).converter(defaultListConverter, function () {
                    return {
                        columns: $scope.options.columns,
                        converters: converters
                    };
                }).then(function (request) {
                    var primaryColumn = columnsHelper.getPrimaryIdx($scope.options.columns);
                    _(request.data.data).each(function (row) {
                        var primaryId = row[primaryColumn].originalText;
                        var processing = $scope.processingActions[primaryId];
                        if (processing && !angular.equals(processing.old, row)) {
                            if ($scope.tableModel) {
                                var rowIndex = _($scope.tableModel.data).findIndex(function (existingRow) {
                                    return existingRow[primaryColumn].originalText === primaryId;
                                });
                                if (rowIndex > -1) {
                                    if (rowMatchesFilters) {
                                        $scope.tableModel.data[rowIndex] = row;
                                    } else {
                                        $scope.tableModel.data.splice(rowIndex, 1);
                                    }
                                }
                            }
                            delete $scope.processingActions[primaryId];
                        }
                    });
                    updateRowClasses();
                    statusUpdateTimer = $timeout(updateEmails, interval);
                });
            }
        }
        $scope.reload();
        $scope.$watch('model.currentModule', function (newVal, oldVal) {
            if (newVal != oldVal) {
                routeHelper.redirectTo('restore-requests', { module: $scope.model.currentModule }, { replace: true });
            }
        });
        $scope.$on('restore-request-approve', function (event, data) {
            executeAction('restore', [data.entityId]);
        });
        $scope.$on('restore-request-deny', function (event, data) {
            executeAction('decline', [data.entityId]);
        });
        function localTimeWithAgo(text) {
            if (!text) {
                return '';
            }
            var time = moment.utc(text).local();
            return time.format('YYYY-MM-DD HH:mm:ss') + ' (' + time.fromNow() + ')';
        }
        $scope.$on('show-restore-request', function (event, data) {
            modals.confirm({
                title: 'Restore request',
                message: 'User requested email restore' + (data.request.restoration_request_dt ? ' on ' + localTimeWithAgo(data.request.restoration_request_dt) : '') + (data.request.restore_commentary ? '<br />User comment:<br />' + data.request.restore_commentary : ''),
                buttons: [
                    {
                        'class': 'restore-dialog-btn restore-dialog-btn-cancel',
                        label: 'Cancel'
                    },
                    {
                        id: 'action',
                        value: 'restore',
                        'class': 'restore-dialog-btn restore-dialog-btn-restore',
                        label: 'Restore'
                    },
                    {
                        id: 'action',
                        value: 'decline',
                        'class': 'restore-dialog-btn restore-dialog-btn-decline',
                        label: 'Decline'
                    }
                ],
                okClass: 'display-none',
                cancelClass: 'display-none'
            }).then(function (params) {
                if (params.action) {
                    executeAction(params.action, [data.request.entity_id]);
                }
            });
        });
    }]);
}());